import React from "react";

function Notify() {
  return (
    <svg
      width="75px"
      height="75px"
      
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 512.003 512.003"
      version="1.1"
      viewBox="0 0 512.003 512.003"
      xmlSpace="preserve"
    >
      <circle cx="257.213" cy="28.991" r="28.991" fill="#CF7B00"></circle>
      <path
        fill="#CF933C"
        d="M228.217 28.991c0 16.012 12.98 28.991 28.991 28.991V0c-16.01 0-28.991 12.98-28.991 28.991z"
      ></path>
      <circle cx="256.001" cy="445.979" r="66.024" fill="#940009"></circle>
      <path
        fill="#FF0029"
        d="M189.977 445.976c0 36.464 29.56 66.024 66.024 66.024V379.951c-36.464 0-66.024 29.559-66.024 66.025z"
      ></path>
      <path
        fill="#FF9800"
        d="M466.898 401.879c-62.965-71.102-97.28-162.596-96.745-257.568l.002-.66c0-63.325-51.335-114.66-114.66-114.66s-114.66 51.335-114.66 114.66c0 .324.001.649.004.972.786 94.597-33.258 186.213-95.729 257.253l-.003.003h421.791z"
      ></path>
      <path
        fill="#F7DC4D"
        d="M256.001 28.998c-.169 0-.338-.007-.507-.007-63.325 0-114.66 51.336-114.66 114.66 0 .324.001.649.004.972.786 94.597-33.258 186.213-95.729 257.253l-.003.003h210.895V28.998z"
      ></path>
      <path
        fill="#E5BF2B"
        d="M453.58 445.976H58.423c-16.546 0-29.96-13.414-29.96-29.96s13.414-29.96 29.96-29.96H453.58c16.546 0 29.96 13.414 29.96 29.96s-13.414 29.96-29.96 29.96z"
      ></path>
      <path
        fill="#005A95"
        d="M412.621 322.486a384.195 384.195 0 01-30.1-79.04h-253.75a384.908 384.908 0 01-29.81 79.04h313.66z"
      ></path>
      <path
        fill="#31AAEF"
        d="M256.001 243.446H128.982a384.832 384.832 0 01-29.811 79.04H256v-79.04z"
      ></path>
      <path
        fill="#F9ED9D"
        d="M256.001 386.056H58.423c-16.546 0-29.96 13.414-29.96 29.96s13.414 29.96 29.96 29.96h197.579v-59.919h-.001z"
      ></path>
    </svg>
  );
}

export default Notify;